import React from "react";
import PropTypes from "prop-types";

export const PagingIcon = ({ view, changeView }) => (
    <div className="paging-icon">
        <a
            data-view="grid"
            className={`icon grid ${view === "grid" ? "active" : ""}`}
            onClick={() => {
                changeView("grid");
            }}
        >
            <i className="fa fa-table" data-view="grid" aria-hidden="true"></i>
        </a>
        <a
            data-view="list"
            className={`icon grid ${view === "list" ? "active" : ""}`}
            onClick={() => {
                changeView("list");
            }}
        >
            <i className="fa fa-list-ul" data-view="list" aria-hidden="true"></i>
        </a>
    </div>
);

PagingIcon.propTypes = {
    view: PropTypes.oneOf(["grid", "list"]),
    changeView: PropTypes.func
};